/**
 * To prevent text injection attack, we have to truncate and capitalize market symbol.
 * So it's not possible to pass any text as parameter.
 * */
export const sanitizeExternalMarketSymbol = (symbol?: string) =>
  symbol?.substring(0, 8).toUpperCase() || '';
